import { config, debug, george, i18n, observable, observer, pr, React, Route, theme, ui } from "aaa";
import AliasContainer from "components/alias/AliasContainer";
import AppBusinessStoreRedirectContainer from "components/appBusinessStoreRedirect/AppBusinessStoreRedirectContainer";
import AppStoreRedirectContainer from "components/appStoreRedirect/AppStoreRedirectContainer";
import AppStoreRedirectContainerCampaign from "components/appStoreRedirect/AppStoreRedirectContainerCampaign";
import AppStoreRedirectContainerDeprecated from "components/appStoreRedirectDeprecated/AppStoreRedirectContainerDeprecated";
import AssetCalculationContainer from "components/assetCalculation/AssetCalculationContainer";
import BSPOptionsContainer from "components/BSPOptions/BSPOptionsContainer";
import CarLeasingContainer from "components/carLeasing/CarLeasingContainer";
import { DebugOverlay } from "components/common/DebugConsole";
import { ToastList } from "components/common/ToastList";
import CreditCardUpgradeContainer from "components/creditCardUpgrade/CreditCardUpgradeContainer";
import JuniorContainer from "components/gJunior/JuniorContainer";
import GooglePayContainer from "components/googlePay/GooglePayContainer";
import HandoverURLTestContainer from "components/handoverURLTest/HandoverURLTestContainer";
import HouseholdInsuranceContainer from "components/householdInsurance/HouseholdInsuranceContainer";
import IchAppContainer from "components/ichApp/IchAppContainer";
import LoginManagementContainer from "components/loginManagement/LoginManagementContainer";
import { PinResetContainer } from "components/pin/views/PinResetContainer";
import PocketsContainer from "components/pockets/PocketsContainer";
import { ReissueCardUpgradeContainer } from "components/reissueCardUpgrade/ReissueCardUpgradeContainer";
import SavingsOptionsContainer from "components/savingsOptions/SavingsOptionsContainer";
import ShopCreditCardBusinessContainer from "components/shopCreditCardBusiness/ShopCreditCardBusinessContainer";
import { ShowCardDataContainer } from "components/showCardData/ShowCardDataContainer";
import { SurveyContainer } from "components/survey/SurveyContainer";
import TeamCardLinkageContainer from "components/teamcardLinkage/TeamcardLinkageContainer";
import TradingPreferencesContainer from "components/tradingPreferences/TradingPreferencesContainer";
import { IS_MASTER } from "config";
import * as _ from "lodash";
import { observe } from "mobx";
import { Redirect, Router, Switch } from "react-router-dom";
import { default as auth, default as authStore } from "stores/AuthStore";
import { debugStore } from "stores/DebugStore";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import profileStore from "stores/ProfileStore";
import routerStore, { history } from "stores/RouterStore";
import * as formValidations from "util/formValidations";
import { ActivateCardContainer } from "../activateCard/ActivateCardContainer";
import { ErrorScreen } from "../common/ErrorScreen";
import { GeorgeWebHeader } from "../common/GeorgeWebHeader";
import { WebView } from "../common/WebView";
import { GIGContainer } from "../gig/GIGContainer";
import { LinkAccountContainer } from "../linkAccount/LinkAccountContainer";
import { QuickDrawdownContainer } from "../quickDrawdown/QuickDrawdownContainer";
import { ReissueCardContainer } from "../reissueCard/ReissueCardContainer";
import { Shop } from "../shop/Shop";
import { StoreContainer } from "../store/StoreContainer";
import { TPPContainer } from "../tpp/TPPContainer";
import { ErrorRoutes, FeatureRoutes } from "./AppRoutes";
import { RoutingManager } from "./RoutingManager";

const Loading = () => <george.LoadingIndicator isLoading height={ui.windowHeight} />;

function defer(Component: any) {
    return (props: any) => (
        <React.Suspense fallback={<Loading />}>
            <Component {...props} />
        </React.Suspense>
    );
}

const AppointmentContainer = defer(React.lazy(() => import(/* webpackChunkName: "Appointment" */"../appointment/AppointmentContainer")));
const SIdentityContainer = defer(React.lazy(() => import(/* webpackChunkName: "SIdentity" */"../sidentity/SIdentityContainer")));
const SIdentitySettingsContainer = defer(React.lazy(() => import(/* webpackChunkName: "SIdentitySettings" */"../sIdentitySettings/SIdentitySettingsContainer")));
const ChangeRepaymentContainer = defer(React.lazy(() => import(/* webpackChunkName: "ChangeRepayment" */"../changeRepayment/ChangeRepaymentContainer")));
const GeoControlContainer = defer(React.lazy(() => import(/* webpackChunkName: "GeoControl" */"../geoControl/GeoControlContainer")));
const ConsumerLoanContainer = defer(React.lazy(() => import(/* webpackChunkName: "ConsumerLoan" */"../loan/ConsumerLoanContainer")));
const BankCardContainer = defer(React.lazy(() => import(/* webpackChunkName: "BankCard" */"../bankCard/BankCardContainer")));
const SavingsContainer = defer(React.lazy(() => import(/* webpackChunkName: "Savings" */"../savings/SavingsContainer")));
const ShopCreditCardContainer = defer(React.lazy(() => import(/* webpackChunkName: "ShopCreditCard" */"../shopCreditCard/ShopCreditCardContainer")));
const OptioPayContainer = defer(React.lazy(() => import(/* webpackChunkName: "OptioPay" */"../optiopay/OptioPayContainer")));
const OptioPayActivationContainer = defer(React.lazy(() => import(/* webpackChunkName: "OptioPay" */"../optiopayActivation/OptioPayActivationContainer")));
const DeferralServiceContainer = defer(React.lazy(() => import(/* webpackChunkName: "DeferralService" */"../deferralService/DeferralServiceContainer")));
const AccidentInsuranceContainer = defer(React.lazy(() => import(/* webpackChunkName: "AccidentInsurance" */"../accidentInsurance/AccidentInsuranceContainer")));
const PensionInsuranceContainer = defer(React.lazy(() => import(/* webpackChunkName: "PensionInsurance" */"../pensionInsurance/PensionInsuranceContainer")));
const LifeInsuranceContainer = defer(React.lazy(() => import(/* webpackChunkName: "LifeInsurance" */"../lifeInsurance/LifeInsuranceContainer")));
const PensionFundsContainer = defer(React.lazy(() => import(/* webpackChunkName: "PensionFunds" */"../pensionFunds/PensionFundsContainer")));
const FitContainer = defer(React.lazy(() => import(/* webpackChunkName: "Fit" */"../fit/FitContainer")));
const LoyaltyContainer = defer(React.lazy(() => import(/* webpackChunkName: "Loyalty" */"../loyalty/LoyaltyContainer")));
const GidSettingsContainer = defer(React.lazy(() => import(/* webpackChunkName: "GidSettings" */"../gidSettings/GidSettingsContainer")));

type IProps = i18n.InjectedIntlProps;

@i18n.injectIntl
@observer
export class AppContainer extends React.Component<IProps, {}> {
    @observable applyMaxWidth?: boolean = undefined;

    // Do not apply maxWidth for store page
    locationDisposer = observe(routerStore, "location", (change: any) => {
        if (routerStore.location) {
            const applyMaxWidth = !_.startsWith(routerStore.location.pathname, "/store") && !_.startsWith(routerStore.location.pathname, "/fit");
            this.applyMaxWidth = applyMaxWidth;
        }
    }, true);

    componentDidUpdate(previousProps: IProps) {
        // This MUST stay here and should not be removed.
        // Reason: In /feature-tests the mount is already done, but settings are not loaded yet,
        // if a feature is started with clientId = georgeclient.
        this.loadLocaleFromSettings();
    }

    constructor(props: any) {
        super(props);
        ui.__ = i18n.bindStr(this.props.intl);
        formValidations.addRules();
    }

    componentDidMount() {
        ui.addResizeListener();
        ui.addDarkModeListener();

        // Always enable DEBUG when we are doing a local test
        if (debug.isLocal()
            && config.DEBUG === false
            && !IS_MASTER
        ) {
            console.log("%c ### local build -> forcing DEBUG to true", "background: rgb(0, 156, 230); color: #fff");
            config.DEBUG = true;
        }

        this.loadLocaleFromSettings();
        this.loadProfile();
    }

    async loadLocaleFromSettings() {
        // George Web does NOT pass locale via query param -> read from settings instead
        if (externalInterfaceStore.isGeorgeWeb && authStore.authorized) {
            try {
                if (!externalInterfaceStore.settingsLocale) {
                    await externalInterfaceStore.loadSettingsLocale();
                }

                let newLocale = externalInterfaceStore.settingsLocale;
                debug.log("### Locale from /settings is", newLocale);

                if (newLocale && newLocale !== auth.locale) {
                    // Set locale if changed
                    auth.locale = newLocale;
                }
            } catch (error) {
                // pass -> we use default instead
            }
        }
    }

    async loadProfile() {
        if (authStore.authorized) {
            try {
                await profileStore.load();
            } catch (error) {
                debug.log("error loading profile");
            }
        }
    }

    componentWillUnmount() {
        ui.removeResizeListener();
        ui.removeDarkModeListener();
        this.locationDisposer();
    }

    withMessage(Component: any, message: string, hideButton?: boolean) {
        return () => <Component {...this.props} message={message} hideButton={hideButton} />;
    }

    // Wait until locale is loaded. This is to make sure that any feature that uses
    // settings below gets them from externalInterfaceStore. For a more detailed explanation see ExternalInterfaceStore.settingsLocale comment
    localeLoaded() {
        // transactionapp gets locale passed as query param -> ok
        if (!externalInterfaceStore.isGeorgeWeb || !authStore.authorized) {
            return true;
        }

        // Loaded locale has already
        return !!externalInterfaceStore.settingsLocale // settings locale is loaded
            && externalInterfaceStore.settingsLocale === authStore.locale // and applied to authStore
            && (this.props.intl as any).locale === externalInterfaceStore.settingsLocale // and applied to intl
            ;
    }

    render() {
        const Message = pr.styledDiv({ padding: 20 });

        const ContainerDiv = pr.styledDiv({
            minHeight: "100vh",
            marginLeft: "auto",
            marginRight: "auto",
            position: "relative"
        });

        const route = (url: string, condition: boolean, Component: any, featureName: string) => (
            <Route path={url} component={condition ? Component : () => <Message>{featureName + " disabled"}</Message>} />
        );

        // This assures, that our translation func is always correct
        ui.__ = i18n.bindStr(this.props.intl);

        if (!this.localeLoaded()) {
            return null;
        }

        const isWeb = externalInterfaceStore.isGeorgeWeb;

        // If the log below shows up more than once after query parsing: It means that a container will
        // be unmounted and mounted again -> Can happen if e.g. a container changes an observable that the AppContainer depends on
        debug.log(
            `%c *** render authorized (this should only log ONCE after query parsing), ` +
            `locale: ${authStore.locale}, isWeb: ${isWeb}, settingsLocale: ${externalInterfaceStore.settingsLocale}`,
            "background: red; color: #fff"
        );

        const isSIdentityFeature = history.location.pathname === "/sidentity" || history.location.pathname.startsWith("/sidentity/");

        return (
            <Router history={history}>
                <RoutingManager>
                    <ContainerDiv style={{ maxWidth: this.applyMaxWidth ? theme.MAX_APP_WIDTH : undefined }}>
                        <ToastList />
                        {debugStore.debug && !IS_MASTER && <DebugOverlay />}
                        {isWeb && authStore.authorized && !externalInterfaceStore.autoforward && !isSIdentityFeature && <GeorgeWebHeader />}
                        {authStore.authorized &&
                            <Switch>
                                {IS_MASTER && <Route exact path="/" component={() => <Message>Feature Tests disabled on PROD</Message>} />}
                                {!IS_MASTER && <Route exact path="/" component={require("../test/FeatureTestsLogin").default} />}
                                {!IS_MASTER && <Route exact path="/feature-tests" component={require("../test/FeatureTests").default} />}
                                {!IS_MASTER && <Route exact path="/pdf-test" component={require("../test/PdfTest").default} />}
                                {!IS_MASTER && <Route exact path="/pdf/:webUrl" component={WebView} />}

                                {isSIdentityFeature && <Redirect from={ErrorRoutes.ERROR} to={FeatureRoutes.SIDENTITY + ErrorRoutes.ERROR} />}
                                {isSIdentityFeature && <Redirect exact from={ErrorRoutes.UNAUTHORIZED} to={FeatureRoutes.SIDENTITY + ErrorRoutes.UNAUTHORIZED} />}
                                {isSIdentityFeature && <Redirect exact from={ErrorRoutes.FORBIDDEN} to={FeatureRoutes.SIDENTITY + ErrorRoutes.FORBIDDEN} />}
                                <Route exact path={ErrorRoutes.UNAUTHORIZED} component={require("../common/Unauthorized").default} />
                                <Route exact path={ErrorRoutes.FORBIDDEN} component={require("../common/Forbidden").default} />
                                <Route exact path={ErrorRoutes.ERROR} component={require("../common/ErrorScreen").default} />
                                <Route exact path={ErrorRoutes.ERROR_MESSAGE} component={require("../common/ErrorScreen").default} />

                                {route(FeatureRoutes.PIN_RESET, config.PIN_RESET_ENABLED, PinResetContainer, "Pin Reset")}
                                {route(FeatureRoutes.SHOW_CARD_DATA, config.SHOW_CARD_DATA, ShowCardDataContainer, "Show Card Data")}
                                {route(FeatureRoutes.APPOINTMENT, config.APPOINTMENT_ENABLED, AppointmentContainer, "Appointment")}

                                {config.SHOP_ENABLED && <Route path={FeatureRoutes.SHOP} component={Shop} />}
                                {route(FeatureRoutes.SHOP_CREDIT_CARD, config.SHOP_CREDIT_CARD_ENABLED, ShopCreditCardContainer, "Credit Card Purchasee")}
                                {route(FeatureRoutes.SHOP_CREDIT_CARD_BUSINESS, config.SHOP_CREDIT_CARD_BUSINESS_ENABLED, ShopCreditCardBusinessContainer, "Credit Card Business Purchasee")}
                                {route(FeatureRoutes.SHOP_BANK_CARD, config.BANK_CARD_ENABLED, BankCardContainer, "Bank Card Purchase Purchase")}
                                {route(FeatureRoutes.SHOP_SAVINGS, config.SAVINGS_ENABLED, SavingsContainer, "Savings Account Purchase")}
                                {route(FeatureRoutes.CONSUMER_LOAN, config.CONSUMER_LOAN_ENABLED, ConsumerLoanContainer, "Consumer Loan")}

                                {route(FeatureRoutes.DEFERRAL_SERVICE, config.DEFERRAL_SERVICE_ENABLED, DeferralServiceContainer, "Deferral Service")}

                                {route(FeatureRoutes.STORE, config.STORE_ENABLED, StoreContainer, "Store")}
                                {route(FeatureRoutes.OPTIOPAY, config.OPTIO_PAY_ENABLED, OptioPayContainer, "OptioPay")}
                                {route(FeatureRoutes.OPTIOPAY_ACTIVATION, config.OPTIO_PAY_ENABLED, OptioPayActivationContainer, "OptioPay Activation")}

                                {route(FeatureRoutes.CHANGE_REPAYMENT, config.CHANGE_REPAYMENT_ENABLED, ChangeRepaymentContainer, "Change Repayment")}
                                {route(FeatureRoutes.QUICK_DRAWDAWN, config.QUICK_DRAWDOWN_ENABLED, QuickDrawdownContainer, "Quick Drawdown")}
                                {route(FeatureRoutes.GEO_CONTROL, config.GEO_CONTROL_ENABLED, GeoControlContainer, "Geo Control")}
                                {route(FeatureRoutes.REISSUE_CARD, config.REISSUE_CARD_ENABLED, ReissueCardContainer, "Reissue Card")}
                                {route(FeatureRoutes.REISSUE_CARD_UPGRADE, config.REISSUE_CARD_UPGRADE_ENABLED, ReissueCardUpgradeContainer, "Reissue Card Upgrade")}
                                {route(FeatureRoutes.ACTIVATE_CARD, config.ACTIVATE_CARD_ENABLED, ActivateCardContainer, "Activate Card")}
                                {route(FeatureRoutes.LINK_ACCOUNT, config.LINK_ACCOUNT, LinkAccountContainer, "Link account to bankcard")}
                                {route(FeatureRoutes.SIDENTITY, config.SIDENTITY_ENABLED, SIdentityContainer, "SIdentity")}
                                {route(FeatureRoutes.SIDENTITY_SETTINGS, config.SIDENTITY_SETTINGS_ENABLED, SIdentitySettingsContainer, "SIdentitySettings")}
                                {route(FeatureRoutes.TPP, config.TPP_ENABLED, TPPContainer, "TPP")}
                                {route(FeatureRoutes.GIG, config.GIG_ENABLED, GIGContainer, "Geschäftsinformationen George")}
                                {route(FeatureRoutes.ACCIDENT_INSURANCE, config.ACCIDENT_INSURANCE_ENABLED, AccidentInsuranceContainer, "Accident Insurance")}
                                {route(FeatureRoutes.PENSION_INSURANCE, config.PENSION_INSURANCE_ENABLED, PensionInsuranceContainer, "Pension Insurance")}
                                {route(FeatureRoutes.LIFE_INSURANCE, config.LIFE_INSURANCE_ENABLED, LifeInsuranceContainer, "Life Insurance")}
                                {route(FeatureRoutes.HOUSEHOLD_INSURANCE, config.HOUSEHOLD_INSURANCE_ENABLED, HouseholdInsuranceContainer, "Household Insurance")}
                                {route(FeatureRoutes.PENSION_FUNDS, config.PENSION_FUNDS_ENABLED, PensionFundsContainer, "Pension Funds")}
                                {route(FeatureRoutes.CAR_LEASING, config.CAR_LEASING_ENABLED, CarLeasingContainer, "Car Leasing")}
                                {route(FeatureRoutes.FIT, config.FIT_ENABLED, FitContainer, "FIT")}
                                {route(FeatureRoutes.LOYALTY, config.LOYALTY_ENABLED, LoyaltyContainer, "Loyalty")}
                                {route(FeatureRoutes.GID_SETTINGS, config.GID_SETTINGS_ENABLED, GidSettingsContainer, "George ID Limit")}
                                {route(FeatureRoutes.USERMANAGEMENT, config.USERMANAGEMENT_ENABLED, AliasContainer, "Usermanagement")}
                                {route(FeatureRoutes.SURVEY, config.SURVEY_ENABLED, SurveyContainer, "Survey")}
                                {route(FeatureRoutes.CREDIT_CARD_UPGRADE, config.CREDIT_CARD_UPGRADE_ENABLED, CreditCardUpgradeContainer, "Credit Card Upgrade")}
                                {route(FeatureRoutes.GOOGLE_PAY, config.GOOGLE_PAY_ENABLED, GooglePayContainer, "Google Pay")}
                                {route(FeatureRoutes.POCKETS, config.POCKETS_ENABLED, PocketsContainer, "Pockets")}
                                {route(FeatureRoutes.APP_STORE_REDIRECT_DEPRECATED, config.APP_STORE_REDIRECT_DEPRECATED_ENABLED, AppStoreRedirectContainerDeprecated, "App Store Redirect deprecated")}
                                {route(FeatureRoutes.APP_STORE_REDIRECT, config.APP_STORE_REDIRECT_ENABLED, AppStoreRedirectContainer, "App Store Redirect New")}
                                {route(FeatureRoutes.APP_STORE_REDIRECT_CAMPAIGN, config.APP_STORE_REDIRECT_CAMPAIGN_ENABLED, AppStoreRedirectContainerCampaign, "App Store Redirect Campaign for testing purposes")}
                                {route(FeatureRoutes.BSP_OPTIONS, config.BSP_OPTIONS_ENABLED, BSPOptionsContainer, "BSP Options")}
                                {route(FeatureRoutes.BSP_OPTIONS_PAYOUT, config.BSP_OPTIONS_PAYOUT_ENABLED, BSPOptionsContainer, "BSP Options Payout")}
                                {route(FeatureRoutes.ASSET_CALCULATION, config.ASSET_CALCULATION_ENABLED, AssetCalculationContainer, "Asset Calculation")}
                                {route(FeatureRoutes.LOGIN_MANAGEMENT, config.LOGIN_MANAGEMENT, LoginManagementContainer, "Login Management")}
                                {route(FeatureRoutes.ICH_APP, config.ICH_APP, IchAppContainer, "Ich App")}
                                {route(FeatureRoutes.TEAMCARD_LINKAGE, config.TEAMCARD_LINKAGE, TeamCardLinkageContainer, "Teamcard Linkage")}
                                {route(FeatureRoutes.JUNIOR, config.JUNIOR, JuniorContainer, "gJunior")}
                                {route(FeatureRoutes.TRADING_PREFERENCES, config.TRADING_PREFERENCES_ENABLED, TradingPreferencesContainer, "Trading Preferences")}
                                {route(FeatureRoutes.HANDOVER_URL_TEST, config.HANDOVER_URL_TEST_ENABLED, HandoverURLTestContainer, "Handover URL Test")}
                                {route(FeatureRoutes.SAVINGS_OPTIONS, config.SAVINGS_OPTIONS_ENABLED, SavingsOptionsContainer, "Savings Options")}
                                {route(FeatureRoutes.APP_BUSINESS_STORE_REDIRECT, config.APP_BUSINESS_STORE_REDIRECT_ENABLED, AppBusinessStoreRedirectContainer, "App Business Store Redirect")}


                                <Route render={this.withMessage(ErrorScreen, ui.__("error.pageNotFound"), true)} />
                            </Switch>
                        }

                        {!authStore.authorized && // Cannot only guard Routes above with fragment -> ReactRouter gets confused with 404 site -> whole <Switch> has to be wrapped
                            <Switch>
                                {!IS_MASTER && <Route exact path="/" component={require("../test/FeatureTestsLogin").default} />}
                                {!IS_MASTER && <Route exact path="/feature-tests" component={require("../test/FeatureTests").default} />}
                                {!IS_MASTER && <Route exact path="/pdf-test" component={require("../test/PdfTest").default} />}
                                {!IS_MASTER && <Route exact path="/pdf/:webUrl" component={WebView} />}
                                {route(FeatureRoutes.APP_STORE_REDIRECT_DEPRECATED, config.APP_STORE_REDIRECT_DEPRECATED_ENABLED, AppStoreRedirectContainerDeprecated, "App Store Redirect")}
                                {route(FeatureRoutes.APP_STORE_REDIRECT, config.APP_STORE_REDIRECT_ENABLED, AppStoreRedirectContainer, "App Store Redirect New")}
                                {route(FeatureRoutes.APP_STORE_REDIRECT_CAMPAIGN, config.APP_STORE_REDIRECT_CAMPAIGN_ENABLED, AppStoreRedirectContainerCampaign, "App Store Redirect Campaign")}
                                {route(FeatureRoutes.BSP_OPTIONS, config.BSP_OPTIONS_ENABLED, BSPOptionsContainer, "BSP Options")}
                                {route(FeatureRoutes.HANDOVER_URL_TEST, config.HANDOVER_URL_TEST_ENABLED, HandoverURLTestContainer, "Handover URL Test")}
                                {route(FeatureRoutes.SAVINGS_OPTIONS, config.SAVINGS_OPTIONS_ENABLED, SavingsOptionsContainer, "Savings Options")}
                                {route(FeatureRoutes.APP_BUSINESS_STORE_REDIRECT, config.APP_BUSINESS_STORE_REDIRECT_ENABLED, AppBusinessStoreRedirectContainer, "App Business Store Redirect")}
                                <Route component={require("../common/Unauthorized").default} />
                            </Switch>
                        }
                    </ContainerDiv>
                </RoutingManager>
            </Router>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/app/AppContainer.tsx